/** Max rows shown on Bulk Export preview search (no pagination). */
export const BULK_EXPORT_PREVIEW_LIMIT = 5;
